module.exports = __webpack_public_path__ + "img/logo_black.b706d833.svg";